import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AboutMePage from './pages/AboutMePage';
import GalleryPage from './pages/GalleryPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { SiteConfigProvider } from './contexts/SiteConfigContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CustomIdeaPage from './pages/CustomIdeaPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import UserDashboard from './pages/UserDashboard';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiesPolicyPage from './pages/CookiesPolicyPage';
import LegalNoticePage from './pages/LegalNoticePage';
import WhatsAppButton from './components/WhatsAppButton';
import Footer from './components/Footer';
import Analytics from './components/Analytics';
import CookieBanner from './components/CookieBanner';
import './App.css';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Cargando...</div>
      </div>
    );
  }

  if (!user || user === false) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" />;
  }

  return children;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <SiteConfigProvider>
          <CartProvider>
            <div className="App">
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalogo" element={<CatalogPage />} />
                <Route path="/producto/:productId" element={<ProductDetailPage />} />
                <Route path="/personaliza" element={<CustomIdeaPage />} />
                <Route path="/cuenta-tu-idea" element={<Navigate to="/personaliza" replace />} />
                <Route path="/sobre-mi" element={<AboutMePage />} />
                <Route path="/galeria" element={<GalleryPage />} />
                <Route path="/carrito" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly={true}>
                      <AdminPanel />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
                <Route path="/politica-cookies" element={<CookiesPolicyPage />} />
                <Route path="/aviso-legal" element={<LegalNoticePage />} />
              </Routes>
              <Footer />
              <WhatsAppButton />
              <Analytics />
              <CookieBanner />
              <Toaster position="top-right" />
            </div>
          </CartProvider>
        </SiteConfigProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;